import React, { useEffect, useState, useCallback } from 'react';
import WarningBanner from '@/components/salesman/WarningBanner';
import BottomNav from '@/components/salesman/BottomNav';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { Trophy } from 'lucide-react';
import api, { fmtIDR, currentMonth } from '@/lib/api';
import { useAuth } from '@/lib/AuthContext';

export default function SalesmanLeaderboard() {
  // Salesman cannot see other salesman revenue; only their own rank
  // We'll compute rank by fetching kpi/my-performance and comparing with target only.
  // For privacy: show own KPI card and target progress only. No other salesman data.
  const { user } = useAuth();
  const [perf, setPerf] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/kpi/my-performance?month=${currentMonth()}`);
      setPerf(data);
    } catch (e) {
      console.error('[SalesmanLeaderboard] gagal load performance:', e);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const progress = Math.min(100, perf?.progress_pct || 0);

  return (
    <div className="min-h-screen bg-background pb-24">
      <WarningBanner />
      <div className="px-4 py-4 max-w-md mx-auto space-y-4">
        <div className="font-heading font-semibold text-lg flex items-center gap-2"><Trophy className="h-5 w-5 text-amber-500" />Performa Saya</div>

        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-base">Bulan {perf?.month}</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <div className="text-xs text-muted-foreground">Omset</div>
              <div className="text-2xl font-heading font-semibold tabular-nums">{fmtIDR(perf?.revenue || 0)}</div>
            </div>
            <div>
              <div className="flex justify-between text-xs mb-1"><span className="text-muted-foreground">Progress ke Target</span><span className="tabular-nums font-medium">{progress.toFixed(1)}%</span></div>
              <Progress value={progress} className="h-3" />
              <div className="text-xs text-muted-foreground mt-1">Target: {perf?.target > 0 ? fmtIDR(perf.target) : 'belum diset'}</div>
            </div>
            <div className="flex items-center justify-between border-t pt-3">
              <div>
                <div className="text-xs text-muted-foreground">Komisi</div>
                <div className="font-heading font-semibold tabular-nums text-emerald-700">{fmtIDR(perf?.commission || 0)}</div>
              </div>
              <Badge variant={perf?.progress_pct >= 100 ? 'default' : 'secondary'} className={perf?.progress_pct >= 100 ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' : ''}>
                {perf?.progress_pct >= 100 ? 'Target Tercapai' : progress > 0 ? 'On Progress' : 'Belum Ada Transaksi'}
              </Badge>
            </div>
          </CardContent>
        </Card>

        <div className="text-xs text-muted-foreground text-center">Data leaderboard sales lain hanya dapat dilihat oleh Owner/Admin.</div>
      </div>
      <BottomNav />
    </div>
  );
}
